module.exports = __webpack_public_path__ + "img/icon-win3.ce20b278.svg";